export default __webpack_public_path__ + "static/media/couple_2.84c27eed.jpg";